import { React, useEffect, useState, useCallback } from 'react';
import * as api from 'services/api';
import _ from 'lodash';
import { useTranslation } from 'react-i18next';

export function InterventionSearch({ handleSearch }) {

    const [interventionTypeId, setInterventionTypeId] = useState('');
    const [tipos, setTipos] = useState([]);
    const [status, setStatus] = useState();
    const { t } = useTranslation();

    const getFormattedDate = (date) => {
        return date.toISOString().split('T')[0]; // formato YYYY-MM-DD
    };

    const today = new Date();
    const tenDaysAgo = new Date(today);
    tenDaysAgo.setDate(today.getDate() - 10);

    const tomorrow = new Date(today);
    tomorrow.setDate(today.getDate() + 1);

    const [from, setFrom] = useState(getFormattedDate(tenDaysAgo));
    const [to, setTo] = useState(getFormattedDate(tomorrow));

    const getTypes = async () => {
        try {
            const response = await api.getInterventionTypes();
            setTipos(response.data);
        } catch (error) {
            console.error('Error cargando tipos:', error);
        }
    };

    useEffect(() => {
        getTypes();
    }, []);

    const onSearch = (e) => {
        e.preventDefault();
        handleSearch({
            from,
            to,
            interventionTypeId,
            status
        });
    };

    return (
        <div onSubmit={onSearch} className="container-fluid mb-4">
            <div className="row g-3">

                <div className="col-6 col-md-3">
                    <label htmlFor="fromDate" className="form-label">{t('int.From')}:</label>
                    <input
                        type="date"
                        id="fromDate"
                        className="form-control"
                        value={from}
                        onChange={e => setFrom(e.target.value)}
                    />
                </div>

                <div className="col-6 col-md-3">
                    <label htmlFor="toDate" className="form-label">{t('int.To')}:</label>
                    <input
                        type="date"
                        id="toDate"
                        className="form-control"
                        value={to}
                        onChange={e => setTo(e.target.value)}
                    />
                </div>

                <div className="col-6 col-md-3">
                    <label htmlFor="interventionType" className="form-label">{t('int.Type')}:</label>
                    <select
                        id="interventionType"
                        className="form-select"
                        value={interventionTypeId}
                        onChange={e => setInterventionTypeId(e.target.value)}
                    >
                        <option value="">{t('int.All')}</option>
                        {tipos.map(t => (
                            <option key={t.id} value={t.id}>{t.name}</option>
                        ))}
                    </select>
                </div>

                <div className="col-6 col-md-3">
                    <label htmlFor="status" className="form-label">{t('int.Status')}:</label>
                    <select
                        id="status"
                        className="form-select"
                        value={status}
                        onChange={e => setStatus(e.target.value)}
                    >
                        <option value="0">Todos</option>
                        <option value="1">{t('int.status_1')}</option>
                        <option value="3">{t('int.status_3')}</option>
                        <option value="4">{t('int.status_4')}</option>
                    </select>
                </div>

                <div className="col-md-2 col-12 d-flex align-items-end">
                    <button
                        type="submit"
                        onClick={onSearch}
                        className="btn btn-primary w-100"
                    >
                        {t('int.Search')}
                    </button>
                </div>

            </div>
        </div>
    );
}

